import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import AddIcon from '@mui/icons-material/Add';
import { FaComments } from 'react-icons/fa';

const LinkItemsMenu = ({
  anchorEl,
  onClose,
  onLinkGoalAction,
  onLinkFeedbackResults,
  onCreateDevPlan,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
    >
      <MenuItem onClick={() => {
        onClose();
        onLinkGoalAction();
      }}>
        <ListItemIcon>
          <LinkIcon sx={{ fontSize: 18 }} />
        </ListItemIcon>
        <ListItemText>Link Goal / Action</ListItemText>
      </MenuItem>
      <MenuItem onClick={() => {
        onClose();
        onLinkFeedbackResults();
      }}>
        <ListItemIcon>
          <FaComments style={{ fontSize: 16 }} />
        </ListItemIcon>
        <ListItemText>Link Feedback Results</ListItemText>
      </MenuItem>
      <Divider />
      <MenuItem
        disabled={!onCreateDevPlan}
        onClick={() => {
          onClose();
          if (onCreateDevPlan) {
            onCreateDevPlan();
          }
        }}
      >
        <ListItemIcon>
          <AddIcon sx={{ fontSize: 18, opacity: onCreateDevPlan ? 1 : 0.5 }} />
        </ListItemIcon>
        <ListItemText>Create Development Plan</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default LinkItemsMenu;
